import { render, staticRenderFns } from "./Life.vue?vue&type=template&id=6bf23e32&scoped=true"
import script from "./Life.vue?vue&type=script&lang=js"
export * from "./Life.vue?vue&type=script&lang=js"
import style0 from "./Life.vue?vue&type=style&index=0&id=6bf23e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf23e32",
  null
  
)

export default component.exports